import React from "react"
import { useSelector } from "react-redux"
import L10n from "../../../lib/carrot-l10n"
import { getInterest } from "../../../reducers/userInfo"
import { getInterestIsFertility } from "derivedSelectors"
import Interests from "utils/Interests"
import { FindAProviderModuleTemplate } from "./FindAProviderModuleTemplate"

const l = new L10n({ locale: "en-US" }).getBoundLocalize()

const FindAProviderModule = () => {
  const { interest, interestIsFertility } = useSelector((state) => ({
    interest: getInterest(state),
    interestIsFertility: getInterestIsFertility(state)
  }))

  if (interestIsFertility) {
    if (interest === Interests.SPERM_FREEZING) {
      return (
        <FindAProviderModuleTemplate
          title="Looking for male fertility services?"
          bodyCopy="The Carrot Care Team can find the right clinics and services for you."
          ctaCopy="Contact Care Team"
          ctaUri="/talk-to-carrot/sendmessage/otherprovidertype"
        />
      )
    } else {
      return (
        <FindAProviderModuleTemplate
          title="Find world-class fertility care near you"
          ctaCopy={l`client.home.browseProviders`}
          ctaUri="/providerfinder"
        />
      )
    }
  }

  if (interest === Interests.ADOPTING) {
    return (
      <FindAProviderModuleTemplate
        title="Looking for adoption services?"
        bodyCopy="The Carrot Care Team can find the right agencies and services for you."
        ctaCopy="Contact Care Team"
        ctaUri="/talk-to-carrot/sendmessage/otherprovidertype"
      />
    )
  }

  if (interest === Interests.GESTATIONAL_CARRIER) {
    return (
      <FindAProviderModuleTemplate
        title="Looking for gestational carrier services?"
        bodyCopy="Gestational carrier services (commonly called surrogacy) can vary based on location. Reach out and we’ll help you find what you need."
        ctaCopy="Contact Care Team"
        ctaUri="/talk-to-carrot/sendmessage/otherprovidertype"
      />
    )
  }

  //default for ungrouped members
  return (
    <FindAProviderModuleTemplate
      title={l`client.home.findWorldClassCare`}
      ctaCopy={l`client.home.browseProviders`}
      ctaUri="/providerfinder"
    />
  )
}

export default FindAProviderModule
